import React, { useEffect, useRef, useCallback, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import styles from "./InputSuggestion.module.css";
import { CircularProgress } from "@material-ui/core";
import {
  setIsTableEditable,
  setVideoLibraryTableStateByName,
  setSelectedVideoPath,
} from "../../../../Redux/Actions/VideoLibraryDataTableActions";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage } from "../../../../utils/webStorage";
const Autocomplete = ({
  options,
  rowId,
  focus,
  rowType,
  rowValue,
  loading,
  mouseDownOnOption,
  filteredOptions,
  error,
  isEditable,
  showOptions,
  selectedOptionIndex,
  breakDownId,
  handleLeftKeyPress,
  handleRightKeyPress,
  handleUpKeyPress,
  handleDownKeyPress,
  index,
  setTableState: setTableStateByName,
  tableItemIndex,
  isTableEditable,
  item,
  setPlaying,
}) => {
  const dispatch = useDispatch();
  const inputRef = useRef();
  const { socket } = useSelector((state) => state?.SocketData);
  const schoolId = getFromLocalStorage("schoolId");
  const userId = getFromLocalStorage("currentUserId");
  const timeoutRef = useRef(null);
  const [typingCoach, setTypingCoach] = useState(null);
  const { firstName, lastName } = useSelector(
    (state) => state?.loggedInUser.userProfile
  );
  const { selectedColumnSet, selectedPlaylist } = useSelector(
    (state) => state?.VideoLibraryDataTable
  );
  useEffect(() => {
    if (focus) {
      inputRef.current.focus();
    }
  }, [focus]);

  const setTableState = useCallback((changes) => {
    setTableStateByName(changes, tableItemIndex, index);
  }, []);

  const handleBlur = () => {
    const changes = {};
    if (!mouseDownOnOption) {
      changes["focus"] = false;
      changes["isEditable"] = false;
    }
    changes["mouseDownOnOption"] = false;
    setTableState(changes);
  };

  const handleOptionClick = (option) => {
    setTableState({ value: option, filteredOptions: [] });
    inputRef.current.focus();
  };

  const handleInputChange = useCallback((e) => {
    const obj = {};
    const value = e.target.value;
    obj["value"] = value;
    const filtered =
      value !== ""
        ? options.filter((option) =>
            option.toLowerCase().includes(value.toLowerCase())
          )
        : [];
    obj["filteredOptions"] = filtered;
    obj["showOptions"] = filtered.length > 0;
    const regEx = rowType === "Number" ? /^[0-9]+$/ : /^[a-zA-Z ]+$/;
    if (regEx.test(value)) {
      obj["error"] = "";
      setVideoLibraryTableStateByName(dispatch, {
        breakDownId,
        rowId,
        changes: { ...obj, error: "" },
      });
      return true;
    } else if (!regEx.test(value) && value !== "") {
      rowType === "Number"
        ? (obj["error"] = "Please Enter Valid Numbers")
        : (obj["error"] = "Please Enter Valid Name");
    } else {
      obj["error"] = "";
    }
    setVideoLibraryTableStateByName(dispatch, {
      breakDownId,
      rowId,
      changes: obj,
    });
  });

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  //added for socket
  const handleTyping = debounce((e) => {
    socket.emit("typing", {
      schoolId,
      userId,
      userName: `${firstName} ${lastName}`,
      columnSetId: selectedColumnSet?.id,
      selectedPlaylist,
      tableColumnId: item?.id,
      tableRowId: rowId,
      message: e.target.value,
    });
  }, 700);

  const handleChange = (event) => {
    //input change handler immediately
    handleInputChange(event);
    // Call the debounced typing handler
    handleTyping(event);
  };

  const highlightMatchedText = (option) => {
    const matchedIndex = option.toLowerCase().indexOf(rowValue?.toLowerCase());

    if (matchedIndex !== -1) {
      const start = option.slice(0, matchedIndex);
      const matched = option.slice(
        matchedIndex,
        matchedIndex + rowValue?.length
      );
      const end = option.slice(matchedIndex + rowValue?.length);

      return (
        <div className="text-center">
          <span className={styles.matched}>{start}</span>
          <span className={styles.matchedBlack}>{matched}</span>
          <span className={styles.matched}>{end}</span>
        </div>
      );
    }

    return option;
  };

  useEffect(() => {
    setTableState({
      selectedOptionIndex: null,
    });
  }, [options]);

  const handleKeyDown = (e) => {
    if (filteredOptions?.length > 0) {
      switch (e.key) {
        case "ArrowDown":
          setTableState({
            selectedOptionIndex:
              selectedOptionIndex === null ||
              selectedOptionIndex === filteredOptions?.length - 1
                ? 0
                : selectedOptionIndex + 1,
          });
          break;

        case "ArrowUp":
          setTableState({
            selectedOptionIndex:
              selectedOptionIndex === null || selectedOptionIndex === 0
                ? filteredOptions?.length - 1
                : selectedOptionIndex - 1,
          });
          break;

        case "Enter":
          const selectedOption =
            selectedOptionIndex !== null
              ? filteredOptions?.[selectedOptionIndex]
              : rowValue;
          setTableState({ value: selectedOption, filteredOptions: [] });

          break;

        case "Escape":
          setTableState({ showOptions: false, filteredOptions: [] });
          break;
      }
    } else {
      switch (e.key) {
        case "ArrowLeft":
          handleLeftKeyPress(index);
          break;

        case "ArrowRight":
          handleRightKeyPress(index);
          break;

        case "ArrowUp":
          handleUpKeyPress(index);
          setSelectedVideoPath(dispatch, {
            id: item?.id,
            videoPath: item?.eventMedia?.videoPath,
          });
          setPlaying(true);
          break;

        case "ArrowDown":
          handleDownKeyPress(index);
          setSelectedVideoPath(dispatch, {
            id: item?.id,
            videoPath: item?.eventMedia?.videoPath,
          });
          setPlaying(true);
          break;
      }
    }
  };

  const handleDoubleClick = () => {
    if (!isTableEditable) {
      setIsTableEditable(dispatch, true);
      setFocusOfInput();
    }
  };

  const handleSingleClick = () => {
    if (isTableEditable) {
      setFocusOfInput();
    }
  };

  const setFocusOfInput = () => {
    setTableState({ focus: true, isEditable: true });
  };

  useEffect(() => {
    if (!socket) return;

    const handleTyping = (data) => {
      console.log(data);
      setTypingCoach(data);

      // Clear previous timeout if any
      clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        setTypingCoach((prev) => ({
          ...prev,
          tableRowId: null,
          tableColumnId: null,
        }));
      }, 1000);
    };

    socket.on("typing", handleTyping);

    return () => {
      socket.off("typing", handleTyping);
      clearTimeout(timeoutRef.current);
    };
  }, [socket, schoolId]);

  return (
    <Tooltip
      placement="top"
      title={`${typingCoach?.userName} is typing` || ""}
      open={
        rowId === typingCoach?.tableRowId &&
        item.id == typingCoach?.tableColumnId
      }
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "#002244",
            color: "white",
            fontSize: "12px",
            padding: "4px",
            borderRadius: "5px",
          },
        },
        arrow: {
          sx: {
            color: "#002244",
          },
        },
      }}
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -17],
            },
          },
        ],
      }}
      arrow
    >
      <div
        className={`${styles.autocompleteContainer} ${
          error && styles.errorField
        }  ${focus && styles.focusedField} h-100`}
      >
        <input
          disabled={typingCoach?.tableRowId && typingCoach?.tableColumnId}
          ref={inputRef}
          type="text"
          value={
            typingCoach?.tableRowId === rowId &&
            typingCoach?.tableColumnId === item.id &&
            typingCoach?.message
              ? typingCoach.message
              : rowValue
          }
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={() => {
            focus && handleBlur();
          }}
          onDoubleClick={handleDoubleClick}
          onClick={handleSingleClick}
          className={styles.autocompleteInput}
          readOnly={!isEditable}
          onFocus={handleTyping}
        />
        {filteredOptions?.length > 0 &&
          rowValue &&
          isEditable &&
          focus &&
          showOptions && (
            <ul
              className={`${styles.autocompleteOptions} shadow`}
              onMouseDown={() => {
                setTableState({ mouseDownOnOption: true });
              }}
            >
              {filteredOptions?.map((option, index) => (
                <li
                  key={index}
                  onClick={() => {
                    handleOptionClick(option);
                  }}
                  className={
                    selectedOptionIndex === index
                      ? `${styles.autocompleteOption} ${styles.selected}`
                      : styles.autocompleteOption
                  }
                >
                  {highlightMatchedText(option)}
                </li>
              ))}
            </ul>
          )}
        <div className="errorMsg fs-14 medium text-center">{error}</div>
        {loading && (
          <div className="breakdown-table-column-loading-animation">
            <CircularProgress size="2rem" />
          </div>
        )}
      </div>
    </Tooltip>
  );
};
export default Autocomplete;
